import BaseCollectionService from "./base.collection.service";
import { ResponseWrapper } from "./response_wrapper";

class PersonalLiabilityPolicyService extends BaseCollectionService {
  constructor() {
    super("personal-liability-policies");
  }
  public async deleteBulk(
    personalLiabilityPolicyIds: string[]
  ): Promise<ResponseWrapper> {
    const path = `personal-liability-policies/bulk-delete`;
    return await this.request(
      { method: "put", url: path, data: { personalLiabilityPolicyIds } },
      { useToken: "access" }
    );
  }
}

export default new PersonalLiabilityPolicyService();
